import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { CandidateEditDialogComponent } from '../candidate-edit-dialog/candidate-edit-dialog.component';

@Component({
  selector: 'app-candidates-approval',
  templateUrl: './candidates-approval.component.html',
  styleUrls: ['./candidates-approval.component.scss']
})
export class CandidatesApprovalComponent implements OnInit {

  processListId: number;
  candidatesApproval: any = [];
  submiting: boolean = false;

  constructor(
    @Inject('MIDIA_ENDPOINT') public mediaEndpoint: string,
    @Inject(MAT_DIALOG_DATA) data: any,
    private dialog: MatDialog,
    private http: HttpService,
    private errorReport: ErrorReportService,
  ) {
    this.processListId = data.processListId;
  }

  ngOnInit(): void {

    const subject = new Subject<any>();
    subject.subscribe({
      next: ({ trigger, scope }: any) => {
        this.submiting = trigger == 'pre';
      }
    })
    this.http.setLoadingIndicator(subject, 'process_list');
    this.getCandidatesToApproval();
  }

  getCandidatesToApproval() {
    this.http.get('process_list:lead', { processList: this.processListId, approvalStatus: true })
      .subscribe(
        (result: any) => this.candidatesApproval = (result.data as number),
        err => this.errorReport.showMessage(err)
      )
  }

  approveCandidate(event: any, candidate: any, approve: boolean) {
    // console.log('CANDIDATE', candidate);
    this.http.save('process_list:approve_candidate', { id: candidate.id2, approve })
      .subscribe(
        () => this.getCandidatesToApproval(),
        err => this.errorReport.showMessage(err)
      )
    event.preventDefault();
    event.stopPropagation();
  }

  openCandidate(candidate) {

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        candidate,
        processListId: this.processListId,
        readOnly: true
      }
    }
    this.dialog.open(CandidateEditDialogComponent, options);

  }

}
